import React from "react";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Button, message, Modal } from "antd";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import FormPasswordInput from "components/FormPasswordInput/FormPasswordInput";
import Title from "components/Title/Title";

import { resetPassword } from "apis/authentication";
import { withAppContext } from "contexts/AppContext/AppContext";
import { buildBaseUri } from "utils/routes";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { success, error, confirm } = Modal;

const ResetPassword = ({ onLogout }) => {
  const history = useHistory();
  const [form] = useForm();

  const onBackButtonClick = () => history.goBack();

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue("password")) {
      return callback("Confirm Password must match New Password!");
    }
    callback();
  };

  const handleOnSaveButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
      };

      confirm({
        title: "Are you sure you want to reset your password?",
        content:
          "After resetting, you will need to use your new password to login",
        icon: <ExclamationCircleOutlined />,
        onOk() {
          resetPassword(payload)
            .then(() => {
              success({
                title:
                  "Password reset successful. Please login again with your new password.",
                onOk() {
                  onLogout();
                  history.push(buildBaseUri());
                },
              });
            })
            .catch((ex) => {
              error({
                title: ex.message,
              });
            });
        },
        onCancel() {},
      });
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <Form form={form}>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "32px" }}
      >
        <ClickableTextButton
          text={Locale.get("resetPassword.backButton")}
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleOnSaveButtonClick}
        >
          {Locale.get("resetPassword.saveButton")}
        </Button>
      </Row>
      <Title marginBottom="32px">{Locale.get("resetPassword.pageTitle")}</Title>

      <Row gutter={16}>
        <Col span={16}>
          <FormPasswordInput
            label={Locale.get("resetPassword.labelCurrentPassword")}
            name="oldPassword"
            requiredErrorMessage={"Please enter your current password."}
          />
        </Col>
        <Col span={16}>
          <FormPasswordInput
            label={Locale.get("resetPassword.labelNewPassword")}
            name="password"
            requiredErrorMessage={"Please enter the new password."}
            checkPattern={true}
          />
        </Col>
        <Col span={16}>
          <FormPasswordInput
            label={Locale.get("resetPassword.labelConfirmPassword")}
            name="confirmPassword"
            requiredErrorMessage={
              "Please re-enter new password. This must be the same as new password."
            }
            extraRules={[{ validator: compareToFirstPassword }]}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default withAppContext(ResetPassword);
